var React = require('react');

function IconElbowFlipped (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M37.1,72c0,18.6,14.6,33.7,32.8,34.2L70,144c-38.7-0.4-70-32.5-70-72C0,32.6,31,0.7,69.6,0\n\tl0.1,37.8C51.6,38.4,37.1,53.5,37.1,72"}));
}

IconElbowFlipped.defaultProps = {"version":"1.1","viewBox":"0 0 70 144","style":{"enableBackground":"new 0 0 70 144"},"xmlSpace":"preserve"};

module.exports = IconElbowFlipped;

IconElbowFlipped.default = IconElbowFlipped;
